module.exports = __webpack_public_path__ + "img/desktop-mask.91fb54ec.png";